import { VariantExchangeGuidanceLevel } from "@redotech/redo-agents-common/returns-agents/exchange-agent/variant-exchange-guidance";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getProductsForVariantExchangeGuidance = {
  name: "getProductsForVariantExchangeGuidance" as const,
  input: z.object({
    guidanceLevel: createEnum(VariantExchangeGuidanceLevel),
    guidanceLevelId: z.string(),
  }),
  output: z.object({
    guidanceLevel: createEnum(VariantExchangeGuidanceLevel),
    guidanceLevelId: z.string(),
    products: z.array(
      z.object({
        productId: z.string(),
        title: z.string(),
        image: z.object({ src: z.string() }),
        variantOptions: z.array(
          z.object({ name: z.string(), values: z.array(z.string()) }),
        ),
      }),
    ),
  }),
};
